// react-shim.js
import * as React from 'react';
export { React };
